// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__z_RfC","item":"PaymentsMobile_item__1RVsV","label":"PaymentsMobile_label__TTxba","amount":"PaymentsMobile_amount__1200P"};